import type { PushNotificationClickAction } from "src/notifications/pushNotificationClickAction.ts";

/**
 * If the service worker opens a new client and sends a click action to it
 * immediately, handling of it is too late in react-code.
 * Therefore, it is saved here and checked on first render.
 */

let initialNotificationAction: PushNotificationClickAction | undefined = undefined;

export const setInitialNotificationAction = (event: PushNotificationClickAction) => {
	initialNotificationAction = event;
};

export const getAndResetInitialNotificationAction = () => {
	const ret = initialNotificationAction;
	// Delete value to prevent duplicate action executions.
	initialNotificationAction = undefined;
	return ret;
};
